import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useKidRoutes } from '@entities/customer'
import { useCustomerStore } from '@entities/customer'
import { useAppBrand } from '@shared/lib/app-brand'
import { useStaticRoutes } from '@shared/lib/routing'
import { useSettingsStore } from '@shared/model'

interface BtnMorePayload {
  route: RouteLocationNormalizedGeneric
}
interface BtnMoreReturn {
  isNew: ComputedRef<boolean>
  disabled: ComputedRef<boolean>
  selected: ComputedRef<boolean>
  pointer: ComputedRef<boolean>
}
export const useBtnMore = (payload: BtnMorePayload): BtnMoreReturn => {
  const customerStore = useCustomerStore()
  const settingsStore = useSettingsStore()

  const { isSmartestMinds } = useAppBrand()

  const {
    isMoreStaticRoute,
  } = useStaticRoutes({ route: payload.route })

  const {
    isRoutePricing,
  } = useKidRoutes()

  const disabled = computed(() => !customerStore.hasData)
  const selected = computed(() => isMoreStaticRoute.value || (customerStore.isTypePaid && isRoutePricing.value))
  const isNew = computed<boolean>(() => settingsStore.isShowNewReferralProgram && !isSmartestMinds)
  const pointer = computed(() => (settingsStore.isShowNewReferralCredits && !isSmartestMinds) || false)

  return  {
    disabled,
    selected,
    isNew,
    pointer,
  }
}
